package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 编译期 style-class 样式层：screen 顶层 `styles { ... }` 块中的单条样式规则。
 *
 * 选择器语法（v1）：可选「类型」（元素 kind，如 `button` / `box`）+ 零或多个 `.类名`。
 * 例：`button`、`.danger`、`button.primary`、`.danger.large`。本期不做后代组合子、不做 :state 伪类。
 *
 * 规则体内 `name = value` 与元素 prop 同样解析（value 走 ExpressionParser，支持 theme.X / 颜色函数 / 字面量）。
 *
 * 命中判定与合并由 [top.wcpe.allincore.dsl.compiler.pipeline.StyleClassApplyPass] 完成；
 * 本 AST 仅承载解析结果，不进入 IR。
 *
 * @property typeKind 选择器的类型部分（元素 kind）；纯 `.类名` 选择器为 null
 * @property classes 选择器的类名部分（`.foo.bar` → ["foo", "bar"]）；纯类型选择器为空
 * @property props 规则体内的属性赋值列表，与元素 prop 同构
 */
data class StyleRuleAst(
    val typeKind: String?,
    val classes: List<String>,
    val props: List<ElementAst.PropAssign>,
    override val position: SourcePosition,
) : AstNode
